// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o_IH","left":"styles_left__3LwrM","right":"styles_right__3zrYb","alert":"styles_alert__1uwlT"};